import { AfterViewInit, Directive, ElementRef } from "@angular/core";

@Directive({
    selector: "[placeholderElement]",
})
export class PlaceholderElementDirective implements AfterViewInit {
    constructor(
        private elementRef: ElementRef,
    ) { }

    public ngAfterViewInit() {
        const { height, width } = this._hostEl.getBoundingClientRect();
        this._hostEl.innerHTML = "";
        this._hostEl.style.height = `${height}px`;
        this._hostEl.style.width = `${width}px`;
    }

    private get _hostEl() {
        return this.elementRef.nativeElement;
    }
}
